import { createReducer, on } from '@ngrx/store';
import { HelpConfig } from '@/app/_core/domain/models/help/help.model';
import { setHelp } from './help.actions';

export interface HelpState {
  help: HelpConfig;
}

export const initialHelpState: HelpState = {
  help: null
};

export const reducer = createReducer<HelpState>(
  initialHelpState,
  on(setHelp, (state, action) => ({
    ...state,
    help: action.payload.help
  }))
);
